import { chakra, shouldForwardProp } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const base = { shouldForwardProp };

export const MotionBox = chakra(motion.div, base);
export const MotionFlex = chakra(motion.div, base);
export const MotionText = chakra(motion.p, base);
export const MotionHeading = chakra(motion.h2, base);
